import { type FunctionComponent, useMemo } from 'react';
import { css } from '@compiled/react';
import { ChampionsHero } from 'components/champions/ChampionsHero';
import { PageWithAnalytics } from 'components/common/analytics-wrapped/PageWithAnalytics';
import { ChampionsIntro } from 'components/champions/ChampionsIntro';
import { ChampionsAdventure } from 'components/champions/ChampionsAdventure';
import { ChampionsAwards } from 'components/champions/ChampionsAwards';
import { FAQ } from 'components/champions/FAQ';
import { ChampionsQuote } from 'components/champions/ChampionsQuote';
import { championsIsActive } from 'services/statsig/featureGates';
import { NewsletterSection } from 'components/sections/homepage/HomepageSections';
import { CommunityApp } from '@atlassian/learning-components';

export const ChampionsPage: FunctionComponent = () => {
  const isChampionsActive = useMemo(() => championsIsActive(), []);
  if (!isChampionsActive) {
    return <div></div>;
  }
  return (
    <PageWithAnalytics eventScreenName="championsScreen">
      <div css={containerStyles}>
        <ChampionsHero />
        <ChampionsIntro />
        <ChampionsAdventure />
        <ChampionsAwards />
        <ChampionsQuote />
        <FAQ />
        <section css={NewsletterStyle}>
          <NewsletterSection app={CommunityApp.CHAMPIONS} />
        </section>
      </div>
    </PageWithAnalytics>
  );
};

const containerStyles = css({
  width: '100%',
});

const NewsletterStyle = css({ marginTop: '24px' });
